import api from '../../../helpers/api';
import Style from './Verify.module.scss';
import {useDispatch} from "react-redux";
import {getUserClinic, loginWithData} from "../../../store/auth-slice";
import {Link, useHistory} from 'react-router-dom';
import {useEffect, useState} from 'react';
import { $t } from 'helpers/translator';

const Verify = (props) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const {id, token} = props.match.params;
    const [loading,
        setLoading] = useState(true);
    const [results,
        setResults] = useState(null);


    useEffect(() => {
        try {
            verifyAccount().then((res) => {
                if (res && res.success) {
                    setResults(res.success);
                }

                setLoading(false);
            });
        } catch (e) {
            console.error(e);
        }

    }, []);

    const verifyAccount = async () => {
        const res = await api.post('/auth/verify/email', {
            id: id,
            token: token
        });

        return res.data;
    }

    const doAutoLogin = async() => {
        setLoading(true);
        try {
            const res = await autoSignIn();
            if (res.success === true) {
                const user = await dispatch(loginWithData(res.data));
                history.push('/');
                if (user.role === 2 || user.role === 3) {
                    await dispatch(getUserClinic());
                }               
            } else {
                window.location = '/login'
            }
        } catch(e) {
            console.error(e)
        }

        setLoading(false);
    }

    const autoSignIn = async () => {
        try {
            const res = await api.post('/auth/login/tmptoken', {
                id: id,
                token: token
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    }

    const sleep = (ms) => {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    return (
        <div className={Style['pageContainer']}>
            <div className={Style['container']}>
                <div className={Style['page']}>
                    <div
                        className={loading
                            ? [Style["loader"], Style["loader-show"]].join(' ')
                            : Style["loader"]}>
                        <svg
                            version="1.1"
                            id="loader-1"
                            x="0px"
                            y="0px"
                            width="40px"
                            height="40px"
                            viewBox="0 0 40 40"
                            enable-background="new 0 0 40 40">
                            <path
                                opacity="0.2"
                                fill="#000"
                                d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946
                                s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634
                                c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"/>
                            <path
                                fill="#000"
                                d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0
                                    C22.32,8.481,24.301,9.057,26.013,10.047z">
                                <animateTransform
                                    attributeType="xml"
                                    attributeName="transform"
                                    type="rotate"
                                    from="0 20 20"
                                    to="360 20 20"
                                    dur="0.5s"
                                    repeatCount="indefinite"/>
                            </path>
                        </svg>
                    </div>
                    {results === true ? <>
                        <h1 className={Style['title']}>{$t('global.verifyEmail.title')}</h1>
                        <p className={Style['text-muted']}>{$t('global.verifyEmail.description')}</p>
                        <div>
                            <button onClick={(e) => {
                                doAutoLogin()
                            }} className={`${Style['btn']} ${Style['btn-primary']}`}> {$t('global.verifyEmail.cta')}
                            </button>
                        </div>
                    </> : <>
                        <h1 className={Style['title']}>{$t('global.verifyEmail.error.title')}</h1>
                        <p className={Style['text-muted']}>{$t('global.verifyEmail.error.description')}</p>
                        <div>
                            <a href="/login" className={`${Style['btn']} ${Style['btn-primary']}`}>{$t('global.verifyEmail.error.cta')}</a>
                        </div>
                    </>}

                </div>
            </div>
        </div>
    )
}

export default Verify;